import {
  Route,
  Navigate,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { routePath } from "./routePath";
import { adminRoutePath } from "./adminRoutePath";
import { GlobalContextProvider } from "stateManagers/GlobalContext";
import { SignIn } from "features/Authentication/pages/SignIn";
import { SignUp } from "features/Authentication/pages/SignUp";
import { GoogleCallback } from "features/Authentication/pages/GoogleCallback";
import { LinkedinCallback } from "features/Authentication/pages/LinkedinCallback";
import { ForgotPassword } from "features/Authentication/pages/ForgotPassword";
import { ResetPassword } from "features/Authentication/pages/ResetPassword";
import { Home } from "features/home/Home";
import { Jobs } from "features/jobs/pages/Jobs";
import { Talents } from "features/talents/pages/Talents";
import JobDetailsRoute from "features/jobs/pages/JobDetailsRoute";
import { ViewJobDetails } from "features/jobs/pages/ViewJobDetails";
import CareerPublicPortal from "features/jobs/pages/CareerPublicPortal";
import { PublicJobDescription } from "features/jobs/pages/publicJobDescription";
import { Folders } from "features/folders/pages/Folders";
import { Pricing } from "features/pricing/pages/Pricing";
import { Settings } from "features/settings/Settings";
import { NotFoundPage } from "components/layout/NotFoundPage";
import { TalentDetails } from "features/talents/pages/TalentDetails";
import { SingleFolder } from "features/folders/pages/SingleFolder";
import { Invite } from "features/invites/pages/Invite";
import Messages from "features/message/pages/Messages";
import { SafeRequireAuth } from "components/auth/SafeRequireAuth";
import { CampaignCapture } from "components/CampaignCapture";
import Team from "features/team/pages/Team";
import { MeetingSettings } from "features/settings/MeetingSettings";
import { GoogleOauthCallback } from "features/Authentication/pages/GoogleOauthCallback";
import { ZoomOauthCallback } from "features/Authentication/pages/ZoomOauthCallback";
import TermsAndConditions from "features/otherPages/TermsAndConditions";
import PrivacyPolicy from "features/otherPages/privacyPolicy";
import { VerifyPayment } from "features/pricing/pages/VerifyPayment";
import { TeamInvite } from "features/invites/components/TeamInvite";

import { AdminSignIn } from "admin/Authentication/pages/SignIn";
import { AdminForgotPassword } from "admin/Authentication/pages/ForgotPassword";
import { AdminResetPassword } from "admin/Authentication/pages/ResetPassword";
import { AdminHome } from "admin/home/Home";
import { AdminJobs } from "admin/jobs/pages/Jobs";
import { AdminTalents } from "admin/talents/pages/Talents";

import { AdminJobDetails } from "admin/jobs/pages/JobDetails";
import { AdminPricing } from "admin/finance/pages/Pricing";
import { AdminFinance } from "admin/finance/Finance";
import { AdminCampaigns } from "admin/campaigns/pages/Campaigns";
import { AdminContextTips } from "admin/contextTips/pages/ContextTips";
import { AdminSettings } from "admin/settings/Settings";
import { AdminTalentDetails } from "admin/talents/pages/TalentDetails";
import { AdminSingleFolder } from "admin/folders/pages/SingleFolder";
import { AdminInvite } from "admin/invites/pages/Invite";
import AdminMessages from "admin/message/pages/Messages";
import { EmailMessaging } from "admin/message/pages/EmailMessaging";
import AdminTeam from "admin/team/pages/Team";
import { AdminRecruiter } from "admin/recruiters/pages/Recruiter";
import { AdminUsers } from "admin/users/pages/Users";
import { AdminRoles } from "admin/users/pages/Roles";
import { AdminRecruiterDetails } from "admin/recruiters/pages/RecruiterDetails";

import Page from "features/cvChat/page";
import HistoryPage from "features/chatHistory/docHistoryPage";
import { JobBoardSettings } from "features/settings/BoardSettings";
import CVTemplate from "features/cvTemplate/pages/Resume";
import { RecruiterDetails } from "features/recruiters/pages/RecruiterDetails";
import { ViewApplicants } from "features/jobs/components/viewApplicants";
import { ResumeUploadPage } from "features/Authentication/pages/UploadResume";
import { JobsCreation } from "features/jobs/pages/JobsCreation";
import { JobsCreation2 } from "features/jobs/pages/JobsCreation2";
import { JobCreationPreview } from "features/jobs/pages/JobsCreationPreview";
import PageHistory from "features/cvChat/page-history";
import { JobsEdit } from "features/jobs/pages/JobsEdit";
import { AddMemberPage } from "features/team/components/AddMember";
import EnterpriseDashboard from "features/enterprise/dashboard/EnterpriseDashboard";
import FeedbackScreen from "features/feedback/pages/FeedbackScreen";
import { RecruierInvite } from "features/invites/pages/RecruierInvite";
import TalentFeedback from "features/feedback/pages/TalentFeedback";
import { JobOffersListPage } from "features/invites/components/talentInvites/JobOffersListPage";
import { ConfirmJobOffer } from "features/invites/components/talentInvites/ConfirmJobOffer";

export const AllRoutes = () => {
  return (
    <GlobalContextProvider>
      <Router>
        <CampaignCapture />
        <Routes>
          <Route path="/sign-in/:type" element={<SignIn />} />
          <Route path="/sign-up/:type" element={<SignUp />} />
          <Route path={routePath.google} element={<GoogleCallback />} />
          <Route path={routePath.linkedin} element={<LinkedinCallback />} />
          <Route
            path={routePath.googleOauth}
            element={<GoogleOauthCallback />}
          />
          <Route path={routePath.zoomOauth} element={<ZoomOauthCallback />} />
          <Route path="/forgot-password/:type?" element={<ForgotPassword />} />
          <Route path={routePath.reset_password} element={<ResetPassword />} />
          <Route
            path={routePath.home}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Home />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.home2}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Home />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.jobOffers}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobOffersListPage />
              </SafeRequireAuth>
            }
          />
          <Route
            path={`${routePath.confirmJobOffer}/:id`}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <ConfirmJobOffer />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.jobs}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Jobs />
              </SafeRequireAuth>
            }
          />

          <Route
            path={`${routePath.feedbacks}/:jobId?`}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <FeedbackScreen />
              </SafeRequireAuth>
            }
          />
          <Route
            path={`${routePath.talentFeedback}`}
            element={<TalentFeedback />}
          />

          <Route
            path="/jobs-add/:id?"
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobsCreation />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.jobsEdit().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobsEdit />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.jobsCreation2}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobsCreation2 />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.jobsPreview}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobCreationPreview />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.uploadResume}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <ResumeUploadPage />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.jobDetails().format}
            element={<JobDetailsRoute />}
          />

          <Route path="/jobs/:id" element={<ViewJobDetails />} />

          <Route path="/career-portal" element={<CareerPublicPortal />} />

          <Route path="/career-portal/:id" element={<PublicJobDescription />} />

          <Route
            path={routePath.viewApplicants().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <ViewApplicants />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.talents}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Talents />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.talentDetails().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <TalentDetails />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.folders}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Folders />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.folderDetails().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <SingleFolder />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.pricing}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Pricing />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.verifyPayment}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <VerifyPayment />
              </SafeRequireAuth>
            }
          />
          <Route path={routePath.teamInvite} element={<TeamInvite />} />

          <Route
            path={routePath.settings}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.education}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.urls}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.experience}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.interests}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.certifications}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.projects}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.profile}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.profileCompany}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.profileCompanySettings}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.documents}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.password}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.notifications}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.billings}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.personalityTest}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Settings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.invitestatus}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Invite />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.invitestatus}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Invite />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.downloadcv().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <CVTemplate />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.meetingSettings}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <MeetingSettings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.postingSettings}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <JobBoardSettings />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.cvchat}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Page />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.cvchatHistory}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <PageHistory />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.chathistory}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <HistoryPage />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.invites}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Invite />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.recruierInvites}
            element={
              <Navigate to={`${routePath.recruierInvites}/pending`} replace />
            }
          />

          <Route
            path={`${routePath.recruierInvites}/:status`}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <RecruierInvite />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.message}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Messages />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.recruiterDetails().format}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <RecruiterDetails />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.messages}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Messages />
              </SafeRequireAuth>
            }
          />

          <Route
            path={routePath.team}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <Team />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.enterpriseDashboard}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <EnterpriseDashboard />
              </SafeRequireAuth>
            }
          />
          <Route
            path={routePath.addteammember}
            element={
              <SafeRequireAuth loginPath={routePath.sign_in}>
                <AddMemberPage />
              </SafeRequireAuth>
            }
          />
          <Route path={routePath.terms} element={<TermsAndConditions />} />

          <Route path={routePath.privacy} element={<PrivacyPolicy />} />

          <Route path="*" element={<NotFoundPage />} />

          {/** Admin Routes */}

          <Route path={adminRoutePath.sign_in} element={<AdminSignIn />} />

          <Route
            path={adminRoutePath.forgot_password}
            element={<AdminForgotPassword />}
          />
          <Route
            path={adminRoutePath.reset_password}
            element={<AdminResetPassword />}
          />
          <Route
            path={adminRoutePath.users}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminUsers />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.roles}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminRoles />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.home}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminHome />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.jobs}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminJobs />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.jobDetails().format}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminJobDetails />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.talents}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminTalents />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.talentDetails().format}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminTalentDetails />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.recruiterDetails().format}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminRecruiterDetails />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.recruiters}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminRecruiter />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.folderDetails().format}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminSingleFolder />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.pricing}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminPricing />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.settings}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminSettings />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.finance}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminFinance />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.campaigns}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminCampaigns />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.contextTips}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminContextTips />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.invites}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminInvite />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.message}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminMessages />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.messages}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminMessages />
              </SafeRequireAuth>
            }
          />
          <Route
            path={adminRoutePath.emailMessages}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <EmailMessaging />
              </SafeRequireAuth>
            }
          />

          <Route
            path={adminRoutePath.team}
            element={
              <SafeRequireAuth loginPath={adminRoutePath.sign_in}>
                <AdminTeam />
              </SafeRequireAuth>
            }
          />
        </Routes>
      </Router>
    </GlobalContextProvider>
  );
};
